import axios from "axios";

const { APP_ENV, AWS_ENV, OEM, AWS_REGION } = process.env;

/**
 * Check internet connection
 * @returns boolean value
 */
export async function isOnline() {
    if (!window.navigator.onLine) return false;

    try {
        const response: any = await axios.head(window.location.origin, {
            headers: {
                "Cache-Control": "no-cache",
                Pragma: "no-cache",
                Expires: "0",
            },
        });
        return response.ok || response.status;
    } catch (e) {
        return false;
    }
}

export const abbreviateFormat = (number: number, decimalPoints = 1) => {
    const SI_SYMBOL = ["K", "M", "G", "T", "P", "E"];

    // what tier? (determines SI symbol)
    const tier = (Math.log10(Math.abs(number)) / 3) | 0;

    // if zero, we don't need a suffix
    if (tier == 0) return Math.round(number);

    // get suffix and determine scale
    const suffix = SI_SYMBOL[tier - 1];
    const scale = Math.pow(10, tier * 3);

    // scale the number
    const scaled = number / scale;

    // format decimal number and add suffix
    const decimalValue = scaled.toFixed(decimalPoints);
    return (
        ((decimalValue.split(".")[1] === "0" && decimalPoints === 1) ||
        decimalValue.split(".")[1] === "00"
            ? decimalValue.split(".")[0]
            : decimalValue) + suffix
    );
};

export const formatCommaSeparator = (number: number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const trimStringValue = (value = "", trimSpace = false) => {
    if (value === " " || trimSpace) return value.trim();
    else return value.replace(/\s+/g, " ");
};

export const warpFileName = (text = "", maxLength = 20) => {
    if (!text || text.length <= maxLength) return text;
    const index = text.lastIndexOf(".");
    const textPrefix = text.slice(0, index);
    const extention = text.substring(index);
    return `${textPrefix.slice(0, maxLength - 2)}..${extention}`;
};

export const getBaseUrl = (): string => {
    const prefixUrl = OEM === "allgo" ? "" : `.${AWS_REGION.split("-")[0]}.appstore`;
    return APP_ENV === "local"
        ? "http://localhost:7000"
        : `https://api.${AWS_ENV !== "prod" ? `${AWS_ENV}.` : ""}${OEM}${prefixUrl}.visteoncloud.com`;
};
